import { apiClient } from '../Client';
import { IToolsReport } from './interface';

export const getFileReport = async (fileReport: IToolsReport[], fileName: string): Promise<File> => {
  const { data } = await apiClient.post(`/Tools/GetReport`, { res: fileReport, fileName }, { responseType: 'blob' });
  return data;
};
